import { render, staticRenderFns } from "./goodsView.vue?vue&type=template&id=50cacccf&scoped=true"
import script from "./goodsView.vue?vue&type=script&lang=js"
export * from "./goodsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cacccf",
  null
  
)

export default component.exports